<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script>
  import { RouterView } from 'vue-router';


  export default {
    name: 'App',
    components: {
    }
  }
</script>

<style></style>
